import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  icon: "assignment",
  plantsWithoutStatInsp: {
    items: [],
    total: 0
  },
  statInsps: {
    items: [],
    total: 0
  },
  statInsp: {},
  statInspItems: [],
  statInspItem: {},
  statInspItemTypes: [
    { id: 1, name: "Timed" },
    { id: 2, name: "Untimed" },
    { id: 3, name: "Recommendation" },
    { id: 4, name: "Observation" },
    { id: 5, name: "SAFed" }
  ],
  statInspItemStatuses: [
    { id: 1, name: "Outstanding", colour: "danger" },
    { id: 2, name: "Complete", colour: "warning" },
    { id: 3, name: "Closed", colour: "success" },
    { id: 4, name: "Queried", colour: "gray" },
    { id: 5, name: "Resolved", colour: "info" },
    { id: 6, name: "Frustrated", colour: "purple" },
    { id: 7, name: "Quote", colour: "quote" }
  ],
  statInspItemTimePeriods: [
    { id: 1, name: "Immediate", intervalInDays: 1 },
    { id: 2, name: "1 Month", intervalInDays: 7 },
    { id: 3, name: "2 Months", intervalInDays: 14 },
    { id: 4, name: "3 Months", intervalInDays: 28 },
    { id: 5, name: "6 Months", intervalInDays: 56 }
  ],
  statPagedInspItems: {
    items: [],
    total: 0
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
